const BaseService = require('@/services/BaseService')

const namespace = 'rooms/types'

const find = (id, options, cb) => {
  BaseService.get(namespace + '/' + id, options, cb);
}

const findAll = (options, cb) => {
  BaseService.get(namespace, options, cb);
}

export {
  find,
  findAll,
}


// WEBPACK FOOTER //
// ./src/services/rooms/TypeService.js